'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('DoneCtrl', DoneCtrl);

  DoneCtrl.$inject = ['$rootScope', '$log', '$stateParams', '$localStorage', '$sessionStorage', 'loadingScreenSvc', 'onboardingRouter', 'user', 'userSvc', 'providerSvc'];

  function DoneCtrl($rootScope, $log, $stateParams, $localStorage, $sessionStorage, loadingScreenSvc, onboardingRouter, user, userSvc, providerSvc) {
    var vm = this;
    vm.user = user;
    vm.navigate = _saveAndNavigate;
    vm.skipComingSoon = !!vm.user.userPreferences.skipComingSoon || false;
    vm.$onInit = _init;

    function _init() {
      $localStorage.$reset();

      //save wellness category and navigate to destination
      if (vm.user) {
        userSvc.saveUser({
          wellnessCategory: vm.user.wellnessCategory || 'PREVENTION'
        }, function () {
          if (!vm.user.vNextMigrationMessageEnabled || !!vm.user.userPreferences.skipComingSoon) {
            _navigate();
          }
        });
      } else {
        if (!vm.user.vNextMigrationMessageEnabled || !!vm.user.userPreferences.skipComingSoon) {

          // Wait until we get the header images before doing anything.
          // This avoids a visual flash when the image loads.
          _setProvider(user).then(function () {
            return loadingScreenSvc.createLoadingScreen(user.organization.name, _navigate);
          });
        }
      }
    }

    function _setProvider(user) {
      var organization, accessCode, group;
      organization = user.organization.shortName;
      accessCode = user.accessCode.accessCode;
      if (user.accessCodeGroup) {
        group = user.accessCodeGroup.shortName;
      }
      return providerSvc.setProvider({
        organization: organization,
        accessCode: accessCode,
        group: group,
        preferences: user.providerPreferences
      });
    }

    function _saveAndNavigate() {
      if (vm.skipComingSoon) {
        userSvc.savePreferences({
          skipComingSoon: vm.skipComingSoon
        }, _navigate, _navigate);
      } else {
        _navigate();
      }
    }

    function _navigate() {
      $log.debug('doneCtrl - stateParams ', $stateParams);

      // Webview post message
      if ($rootScope.isMobileWebView) {
        $rootScope.sendWebViewPostMessage('home');
        return;
      }

      // we got a redirection header, we should go there
      if ($stateParams.redirecturl) {
        $sessionStorage.redirectUrl = $stateParams.redirecturl;
      }
      onboardingRouter.goToNextStep();
    }
  }
})();